import MapIcon from "@mui/icons-material/Map";
import CleaningServicesIcon from "@mui/icons-material/CleaningServices";
import ScoreIcon from "@mui/icons-material/Score";
import DomainIcon from "@mui/icons-material/Domain";
import CheckIcon from "@mui/icons-material/Check";
import WebIcon from "@mui/icons-material/Web";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";

export const statusList = [
  { key: "0", label: "Requested" },
  { key: "1", label: "Processing" },
  { key: "2", label: "Completed" },
  { key: "3", label: "Cancelled" },
  { key: "4", label: "Failed" },
  { key: "5", label: "Not Implemented" },
];

export const statusKeys = statusList.map((status) => status.key);

export const tableList = [
  {
    key: "CheckRecords",
    label: "Check Records",
    icon: <CheckIcon />,
  },
  {
    key: "CleaningTask",
    label: "Cleaning",
    icon: <CleaningServicesIcon />,
  },
  {
    key: "MasterTask",
    label: "Master",
    icon: <DomainIcon />,
  },
  {
    key: "Frontend",
    label: "Frontend",
    icon: <WebIcon />,
  },
  {
    key: "MdaExtract",
    label: "Mda Extract",
    icon: <CloudDownloadIcon />,
  },
  {
    key: "ScoringTask",
    label: "Scoring",
    icon: <ScoreIcon />,
  },
  {
    key: "AutoCleansing",
    label: "Auto Cleansing",
    icon: <CleaningServicesIcon />,
  },
  {
    key: "MappingTask",
    label: "Mapping",
    icon: <MapIcon />,
  },
];
